<template>
  <div class="col-12">
    <!-- Latest Sermons -->
    <div class="latest-sermons mb-100 row" :key="reload">
    
        <!-- Single Sermons Area -->
        <div class="single-sermons col-md-4" v-for="sermon in sermons" :key="sermon.id" >
            <div class="sermons-content  align-items-center m-1" :class="sermon.isLoading? 'glow':'shadow'">
                <!-- Sermons Thumbnail -->

                <div :style="`background-image:url(${sermon.cover || 'https://img.youtube.com/vi/r8daNVP4V4U/0.jpg'})`"
                     style="widht:100%; height:15rem;                                      
                            background-size:100% auto; 
                            background-repeat:no-repeat; background-position: center;
                            background-color:#111"
                    />
                      
                <!-- Sermons Content -->
                <div class="sermons-text" v-if="sermon.isLoading" 
                    style="height:148px; background:url('img/thumbnail2.jpg'); background-size:100% 100%;">                  
                </div>

                <div class="sermons-text" v-if="!sermon.isLoading">
                    <a  :href="sermon.videoPath" target="_blank">
                        <h6 style="height:2.5rem; overflow: hidden;text-overflow: ellipsis">{{sermon.title}}</h6>
                    </a>

                    <p>{{sermon.preacherName}}</p>

                    <p class="date" v-if="sermon.date">{{sermon.date.substr(0,10)}}</p>

                    <div class="row">
                        <div class="col">
                            <a :href="sermon.videoPath" v-if="sermon.videoPath!='no asignado'">
                                video <i class="fa fa-play" aria-hidden="true"></i>
                            </a>
                            <a class="ml-3" :href="sermon.audioPath" v-if="sermon.audioPath!='no asignado'">
                                audio <i class="fa fa-volume-up" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="all-events-btn">
            <router-link to="sermons" class="btn faith-btn active ml-3">Ver Todos</router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      sermons: [
        { Picture: "/img/thumbnail.jpg", isLoading: true },
        { Picture: "/img/thumbnail.jpg", isLoading: true },
        { Picture: "/img/thumbnail.jpg", isLoading: true },
        { Picture: "/img/thumbnail.jpg", isLoading: true },
        { Picture: "/img/thumbnail.jpg", isLoading: true },
        { Picture: "/img/thumbnail.jpg", isLoading: true },
      ],
      reload: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
      
        const url = this.$store.state.url + "api/sermons/last";
        const req = await fetch(url);
      
        let data = await req.json();
        
        for (let i = 0; i < data.length; i++) {
          await setTimeout(() => {
            const sermon = data[i];
            this.sermons[i] = sermon;
            this.reload++;
          }, (i + 1) * 300);
        }          
      } catch (error) {
        console.error(error);
      }
    },
    setImages(list) {
      for (let i = 0; i < list.length; i++) {
        list[i].Picture = this.getSermonImage(list[i].VideoPath);
        list[i].HasAudio = !list[i].AudioPath.includes("asignado");
        list[i].HasVideo = !list[i].VideoPath.includes("asignado");
        if (list[i].HasVideo == false) {
          list[i].Picture = "http://img.youtube.com/vi/r8daNVP4V4U/0.jpg";
          list[i].VideoPath = list[i].AudioPath;
        } else if (!list[i].VideoPath.includes("youtube")) {
          list[i].Picture = "http://img.youtube.com/vi/r8daNVP4V4U/0.jpg";
        }
      }
      return list;
    },
    getSermonImage(url) {
      let n = url.lastIndexOf("/");
      let id = url.substring(n);
      let newUrl = "http://img.youtube.com/vi" + id + "/0.jpg";
      return newUrl;
    },
  },
};
</script>

<style lang="css" scoped>
.glow {
  animation: glow 1s infinite alternate;
}

@keyframes glow {
  from {
    box-shadow: 0 0 10px -10px #ddd;
  }
  to {
    box-shadow: 0 0 10px 10px #ddd;
  }
}

@media screen and (max-width: 400px) {
  .sermons-thumbnail {
    height: 200px !important;
  }
}
</style>